import { getGlobalLookup } from "../deprecated/lookup";

import { getWindow } from "./getWindow";

// Route through getGlobalLookup so that SSR request-scoped lookups
// (see @faire/next-utils/initializers/clientComponentSSR) are honored.
export const getLocation = (): Location | undefined =>
  getGlobalLookup()<Location>("location") ?? getWindow()?.location;

export const getLocationOrThrow = (): Location => {
  const location = getLocation();
  if (!location) {
    throw new Error("Unable to resolve window.location");
  }
  return location;
};
